<template>
  <div class="main">
    <!-- 头部进度条 -->
    <a-row>
      <a-col class="head" :span="24">
        <el-steps :active="current" finish-status="success" simple style="margin-top: 20px">
          <el-step :key="index" v-for="(item, index) in stepDate" :title="item.title"></el-step>
        </el-steps>
      </a-col>
    </a-row>
    <!-- 第一步单选框施工选择 -->
    <transition name="fade">
      <div class="step1" v-if="current == 0">
        <div class="imgBoxStyle">
          <div class="constructionImg1" v-if="step1Radio == '1'"></div>
          <div class="constructionImg2" v-if="step1Radio == '2'"></div>
        </div>

        <div class="choseBox">
          <el-radio v-model="step1Radio" label="1" border>独立基礎施工用</el-radio>
          <el-radio v-model="step1Radio" label="2" border>コンクリートブロック上施工用</el-radio>
        </div>
      </div>
    </transition>

    <!-- 第二部选框 平台选择 -->
    <transition name="fade1">
      <div class="step2" v-if="current == 1">
        <!-- 如果为独立施工 -->
        <div class="step2RadioStyle" v-if="step1Radio == 1">
          <el-radio-group v-model="step2Radio1" @change="chooseDrawACFn($event)">
            <div class="chooseItemStyle">
              <el-radio label="15-11">T-15アルミ柱 (11段貼)</el-radio>
            </div>
            <div class="chooseItemStyle">
              <el-radio label="18-13">T-18アルミ柱 (13段貼)</el-radio>
            </div>
            <div class="chooseItemStyle">
              <el-radio label="20-15">T-20アルミ柱 (15段貼)</el-radio>
            </div>
            <div class="chooseItemStyle">
              <el-radio label="24-18">T-24アルミ柱 (18段貼)</el-radio>
            </div>
          </el-radio-group>

          <el-select class="selectStyle" v-model="fenceRange" placeholder="请选择平台">
            <el-option v-for="(item, index) in fenceSize" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>

        <!-- 如果混合施工 -->
        <div class="step2RadioStyle" v-if="step1Radio == 2">
          <el-radio-group v-model="step2Radio2" @change="chooseDrawACFn($event)">
            <div class="chooseItemStyle">
              <!-- <el-radio label="8-6">T-8 (6段段貼)</el-radio> -->
              <el-radio label="8-6">T-8 (6段貼)</el-radio>
            </div>
            <div class="chooseItemStyle">
              <el-radio label="10-7">T-10 (7段貼)</el-radio>
            </div>
            <div class="chooseItemStyle">
              <el-radio label="12-9">T-12 (9段貼)</el-radio>
            </div>
          </el-radio-group>

          <el-select class="selectStyle" v-model="fenceRange" placeholder="请选择平台">
            <el-option v-for="(item, index) in fenceSize" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>

        <!-- 如果为独立施工 -->
        <div class="step2Drawing" v-if="step1Radio == 1">
          <div class="constructionImg">
            <!-- 动态图片 -->
            <img :src="require(`../assets/${fenceRange}.jpg`)" />
          </div>
        </div>
        <!-- 如果混合施工 -->
        <div class="step2Drawing" v-if="step1Radio == 2">
          <div class="constructionImg">
            <!-- 动态图片展示 -->
            <img :src="require(`../assets/${fenceRange}.jpg`)" />
          </div>
        </div>
      </div>
    </transition>

    <!-- 第三步选框 长度选择-->
    <transition name="fade1">
      <div class="step3" v-if="current == 2">
        <!-- <el-radio-group v-model="chooseSize" class="chooseSizeStyle">
          <el-radio-button label="1">固定尺寸</el-radio-button>
          <el-radio-button label="2">自由尺寸</el-radio-button>
        </el-radio-group>-->
        <div class="chooseSizeStyle" v-if="chooseSize == 1">
          <h3>长度选择(mm)</h3>
          <el-input-number controls-position="right" class="inputNumStyle" :min="1000" type="number" :max="200000" v-model="fenceNum1[0]" :step="1000" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[1]" :step="1000" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[2]" :step="1000" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[3]" :step="1000" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[4]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[5]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[6]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[7]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[8]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
          <el-input-number controls-position="right" class="inputNumStyle" :min="0" :max="200000" v-model="fenceNum1[9]" :step="1000" type="“number”" @keydown.native="channelInputLimit"></el-input-number>
        </div>
        <h3>〇 全長寸法自由入力</h3>
        <h4 style="margin-bottom: 45px">ライン每入力</h4>
        <div class="chooseSizeStyle" v-if="chooseSize == 2">
          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第1ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[0]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第2ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[1]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第3ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[2]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第4ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[3]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第5ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[4]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第6ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[5]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第7ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[6]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第8ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[7]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第9ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[8]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>

          <div class="lengthInputStyle">
            <h4 style="margin-bottom: -10px">第10ライン</h4>
            <el-input-number controls-position="right" class="inputNumStyle" :min="400" :max="200000" v-model="fenceNum2[9]" :step="1" size="small"></el-input-number>
            <span style="margin: 0 10px 0 -10px">mm</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- 第三步选框 基础颜色选择 -->
    <transition name="fade1">
      <div class="step4" v-show="current == 3">
        <div :style="{ height: fenceregionHeight }" class="fenceregion">
          <!-- 柱子样式 -->
          <div class="colstyle">
            <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
              <div
                v-for="(obj, index) in fenceColorData"
                :key="index"
                class="jointitemstyle"
                :style="{
                  backgroundColor: middleColColor,
                  paddingTop: jointitemstyleSize
                }"
              ></div>
            </div>

            <!-- <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
              <div
                v-for="(obj, index) in fenceColorData"
                :key="index"
                class="jointitemstyle"
                :style="{
                  backgroundColor: middleColColor,
                  paddingTop: jointitemstyleSize
                }"
              ></div>
            </div> -->
            <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
              <div
                v-for="(obj, index) in fenceColorData"
                :key="index"
                class="jointitemstyle"
                :style="{
                  backgroundColor: middleColColor,
                  paddingTop: jointitemstyleSize
                }"
              ></div>
            </div>
          </div>

          <div class="fencestyle">
            <!-- 板子样式 -->
            <div class="fenceitem" v-for="(obj, index) in fenceColorData" :key="index" :style="{ backgroundColor: obj.color, height: fenceitemHeight }" @click="changeColorFn(index)"></div>
          </div>
        </div>
        <div class="chooseColorStyle">
          <div class="topItemStyle">
            <h3 class="middleTitleStyle">ボード(板)の色を選択してください</h3>
            <div class="colorColStyle">
              <div class="colorRegion">
                <div @click="changeBaseColor('#fad390')" class="colorItemStyle" style="background-color: #fad390"></div>
                <div @click="changeBaseColor('#8E6032')" class="colorItemStyle" style="background-color: #8e6032"></div>
                <div @click="changeBaseColor('#8C9292')" class="colorItemStyle" style="background-color: #8c9292"></div>
              </div>
              <el-radio-group v-model="baseColor" class="fencecolorStyle1" @change="changeBaseColor($event)">
                <el-radio label="#fad390">オーク（OK）</el-radio>
                <el-radio label="#8E6032">チーク（TK）</el-radio>
                <el-radio label="#8C9292">シルバーグレー（SG）</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="topItemStyle">
            <h3 class="middleTitleStyle" style="margin-top: 20px">柱の色を選択してください</h3>
            <div class="colorColStyle">
              <div class="colorRegion">
                <div @click="middleColColor = '#e0d1aa'" class="colorItemStyle" style="background-color: #e0d1aa"></div>
                <div @click="middleColColor = '#394044'" class="colorItemStyle" style="background-color: #394044"></div>
              </div>
              <el-radio-group v-model="middleColColor" class="fencecolorStyle1">
                <el-radio label="#e0d1aa">ウォームグレー（WG）</el-radio>
                <el-radio label="#394044">ブラック（BK）</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 第四步选框 颜色选择-->
    <transition name="fade1">
      <div class="step4-1" v-show="current == 4">
        <h3 style="text-align: center">ボード(板)・をクリックすれば、色を自由に変更できます</h3>

        <div class="step4Style">
          <!-- 左侧围栏样式 -->
          <div :style="{ height: fenceregionHeight }" class="fenceregion fenceregion4-1">
            <!-- 柱子样式 -->
            <div class="colstyle">
              <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
                <div
                  v-for="(obj, index) in fenceColorData"
                  :key="index"
                  class="jointitemstyle"
                  :style="{
                    backgroundColor: middleColColor,
                    paddingTop: jointitemstyleSize1
                  }"
                ></div>
              </div>

              <!-- <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
                <div
                  v-for="(obj, index) in fenceColorData"
                  :key="index"
                  class="jointitemstyle"
                  :style="{
                    backgroundColor: middleColColor,
                    paddingTop: jointitemstyleSize
                  }"
                ></div>
              </div> -->
              <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
                <div
                  v-for="(obj, index) in fenceColorData"
                  :key="index"
                  class="jointitemstyle"
                  :style="{
                    backgroundColor: middleColColor,
                    paddingTop: jointitemstyleSize1
                  }"
                ></div>
              </div>
            </div>

            <div class="fencestyle">
              <!-- 板子样式 -->
              <div class="fenceitem" v-for="(obj, index) in fenceColorData" :key="index" :style="{ backgroundColor: obj.color, height: fenceitemHeight }" @click="changeColorFn(index)"></div>
            </div>
          </div>

          <!-- 右侧围栏颜色选择 -->
          <div class="chooseColorStyle">
            <div>
              <el-button class="resetBtn" size="small" round @click="resetColorFn()">ベースカラーにリセット</el-button>
            </div>
            <div class="middleItemStyle">
              <h3 class="middleTitleStyle">
                ボード(板)の色を変更する
                <!-- <el-checkbox class="changeStyle" v-model="isAllChange">全部替换</el-checkbox> -->
              </h3>
              <div class="colorColStyle">
                <div class="colorRegion">
                  <div @click="changeColor('fad390')" class="colorItemStyle" style="background-color: #fad390"></div>
                  <div @click="changeColor('8E6032')" class="colorItemStyle" style="background-color: #8e6032"></div>
                  <div @click="changeColor('8C9292')" class="colorItemStyle" style="background-color: #8c9292"></div>
                </div>
                <el-radio-group class="fencecolorStyle1" v-model="fencecolor" @change="changeColor($event)">
                  <el-radio label="fad390">オーク（OK）</el-radio>
                  <el-radio label="8E6032">チーク（TK）</el-radio>
                  <el-radio label="8C9292">シルバーグレー（SG）</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 第五步选框 防开框 -->
    <transition name="fade1">
      <div class="step4" v-if="current == -1">
        <div :style="{ height: fenceregionHeight }" class="fenceregion">
          <!-- 柱子样式 -->
          <div class="colstyle">
            <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
              <div
                v-for="(obj, index) in fenceColorData"
                :key="index"
                class="jointitemstyle"
                :style="{
                  backgroundColor: middleColColor,
                  paddingTop: jointitemstyleSize
                }"
              ></div>
            </div>

            <div class="colstyleitem" :style="{ backgroundColor: middleColColor }"></div>
            <div class="colstyleitem" :style="{ backgroundColor: middleColColor }">
              <div
                v-for="(obj, index) in fenceColorData"
                :key="index"
                class="jointitemstyle"
                :style="{
                  backgroundColor: middleColColor,
                  paddingTop: jointitemstyleSize
                }"
              ></div>
            </div>
          </div>

          <div class="fencestyle">
            <!-- 板子样式 -->
            <div class="fenceitem" v-for="(obj, index) in fenceColorData" :key="index" :style="{ backgroundColor: obj.color, height: fenceitemHeight }" @click="changeColorFn(index)"></div>
          </div>
        </div>
        <div class="chooseColorStyle">
          <div class="chooseFixedStyle"></div>
          <div class="bottomItemStyle">
            <h3 class="middleTitleStyle">開き止め框の選択</h3>
            <el-radio-group class="fixStyle" v-model="isHaveFixed" @change="changeFixedFn($event)">
              <el-radio :label="1" border>有</el-radio>
              <el-radio :label="0" border>無</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- <div class="step4fence" v-for="(item, index) in fenceDate.fenceData " :key="item.canvasID">
          <fenceComponents :ref="index" :columnColor="item.columnColor"
            :colorData="item.colorData" :canvasId="item.canvasID" :reallength="item.alllength"
            :colheight="fenceDate.fenceSize.colHeight" :boardNum="fenceDate.fenceSize.boardNum"></fenceComponents>
        </div> -->
      </div>
    </transition>

    <!-- 第五步选框 报价单 -->
    <div class="step5bottomstyle" v-if="current == 5">
      <div v-for="(item, index) in quotationList" class="step5" :key="index">
        <div>見積条件</div>
        <!-- <div>ルミナスボーダー</div> -->
        <div>
          長さ
          <span>{{ item.allLength }}mm</span>
        </div>
        <div>
          高さ
          <span>{{ item.platType | modelchangeFilter }}</span>
        </div>
        <el-table class="tableStyle" :data="item.quotationDataList" border style="width: 100%" :summary-method="(e) => getSummaries(e, index)" show-summary>
          <el-table-column prop="goodsCode" label="品番"></el-table-column>
          <el-table-column prop="goodsName" label="商品名" width="400"></el-table-column>
          <el-table-column prop="color" label="色"></el-table-column>
          <el-table-column prop="count" label="数量" min-width="160">
            <template slot-scope="scope">
              <el-input-number :min="0" size="small" v-model="scope.row.count"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" label="単価">
            <template slot-scope="scope">¥{{ scope.row.unitPrice | numberToCurrency }}</template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="金額">
            <template slot-scope="scope">¥{{ (scope.row.unitPrice * scope.row.count) | numberToCurrency }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="step5 total">
        <span class="alltotalPrice">ライン計：¥{{ alltotalPrice }}</span>
      </div>
      <div v-show="false" class="step4fence" v-for="(item, index) in fenceDate.fenceData" :key="item.canvasID">
        <fenceComponents :ref="index" :columnColor="item.columnColor" :colorData="item.colorData" :canvasId="item.canvasID" :reallength="item.alllength" :colheight="fenceDate.fenceSize.colHeight" :boardNum="fenceDate.fenceSize.boardNum"></fenceComponents>
      </div>
    </div>

    <!-- 步骤按钮 -->
    <div class="stepsbtn">
      <el-button icon="el-icon-caret-left" type="primary" plain round v-if="current !== 0" @click="backStepFn()"></el-button>

      <el-button icon="el-icon-caret-right" type="primary" round v-if="current !== 5" @click="nextStepFn()">
        <!-- <i class="el-icon-arrow-right el-icon--right"></i> -->
      </el-button>
      <el-button type="primary" round v-if="current === 5" @click="generatequotationFn()">見積書作成(PDF)</el-button>
      <el-button type="primary" round v-if="current === 5" @click="getCsvFn()">CSV作成</el-button>
      <el-button type="primary" round v-if="current === 5" @click="finishFn()">閉じる</el-button>
    </div>
  </div>
</template>

<script>
import download from 'downloadjs'; // pdf下载

import fenceComponents from '@/components/fenceComponentsNew.vue'; // 引入生成围栏组件

import { numberToCurrencyNo } from '@/utils/utils'; // 过滤千位符

import { Message } from 'element-ui'; // 引入消息提示，不单独引样式有些问题

import { getquotationHttp, getquotationPDFHttp, getquotationCSVHttp } from '@/utils/api'; // 获取后台接口

export default {
  components: {
    fenceComponents
  },
  data() {
    return {
      fenceDate: {}, // 围栏生成数据保存位置

      fenceAllData: [], //需要传给后台的全部数据

      // 当前进度
      current: 0,

      // 步骤条数据
      stepDate: [
        {
          title: '設置条件'
        },
        {
          title: '高さの選択'
        },
        {
          title: '長さの選択'
        },
        {
          title: '色の選択'
        },
        {
          title: 'アクセント色の選択'
        },
        // {
        //   title: '開き止め框の選択'
        // },
        {
          title: '見積数量確認・変更画面'
        }
      ],

      step1Radio: '1',
      step2Radio2: '8-6',
      step2Radio1: '24-18',
      fenceSize: [],
      chooseSize: '2',
      fenceRange: '15-11',

      imgsrc: '',
      isAllChange: false, // 是否颜色全部替换

      fenceNum1: [0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined], // 固定1000mm
      fenceNum2: [0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined], // 自由选择
      temporarilyfenceNum: [], // 暂存长度数据
      middleColColor: '#394044', // 中间固定柱子
      fenceColorData: [], // 围栏颜色数据
      fencecolor: '8E6032', // 板子的颜色
      baseColor: '#8E6032', // 所有物品的基础颜色
      isHaveFixed: 1, // 是否添加防开框
      colorIndex: 0, // 记录当前板索引
      tableData: [
        {
          type: 'DRM11WH',
          name: 'ルミナスボーダー　標準ボード（2枚入）WH',
          color: 'ホワイト（WH）',
          num: 1,
          unitPrice: 6600,
          totalPrice: 6600
        },
        {
          type: 'DRM11WH',
          name: 'ルミナスボーダー　標準ボード（2枚入）WH',
          color: 'ホワイト（WH）',
          num: 2,
          unitPrice: 6600,
          totalPrice: 6600
        },
        {
          type: 'DRM11WH',
          name: 'ルミナスボーダー　標準ボード（2枚入）WH',
          color: 'ホワイト（WH）',
          num: 3,
          unitPrice: 6600,
          totalPrice: 6600
        }
      ],
      pageNum: 1, // 当前页码为1
      quotationList: [], // 报价单数据
      alltotalPrice: null,
      fenceregionHeight: '80%', // 围栏高度
      fenceitemHeight: '6%', // 板子高度设置
      jointitemstyleSize: '50%', // 基础颜色选择与防开框铝板高度
      jointitemstyleSize1: '50%', // 颜色选择页面铝板高度
      fixColNum: null,
      lastStructure: null,
      lastStructureType: null
    };
  },
  watch: {
    quotationList: {
      handler() {
        // 深度监听报价单数据变化 动态计算每面合计与所有面总计
        this.quotationList.forEach((item) => {
          item.quotationDataList.forEach((col) => {
            col.totalPrice = col.count * col.unitPrice; // 每行总价=数量* 单价
          });
          item.itemTotal = item.quotationDataList
            .map((row) => row.totalPrice) // 取每行的总价
            .reduce((total, num) => total + num); // 每行总价相加
        });
        this.alltotalPrice = this.quotationList
          .map((row) => row.itemTotal) // 每面总价
          .reduce((total, num) => total + num); // 每面总价相加
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    // 防止输入框输入
    channelInputLimit(e) {
      e.returnValue = '';
    },

    // 上一步
    backStepFn() {
      this.current--;
      if (this.current == 3) {
        // 重置基础色
        this.resetColorFn();
      }
    },

    // 下一步
    nextStepFn() {
      if (this.current == 0) {
        if (this.step1Radio == 1) {
          this.chooseDrawACFn(this.step2Radio1);
        } else if (this.step1Radio == 2) {
          this.chooseDrawACFn(this.step2Radio2);
        }
      }
      if (this.current == 1) {
        if (this.step1Radio == 1) {
          // 如果为独立施工
          this.fenceDate.fenceSize = this.sizeFilter(this.fenceRange); // 通过型号过滤板数量和高度
        } else if (this.step1Radio == 2) {
          // 如果为混合施工
          this.fenceDate.fenceSize = this.sizeFilter(this.fenceRange); // 通过型号过滤板数量和高度
        }
        // 根据型号确定围栏示意的高度
        this.setSelectionHeight(this.fenceDate.fenceSize);
      }

      // 确定长度数据
      if (this.current == 2) {
        this.fencecolor = '8E6032';
        const data = [];
        if (this.chooseSize == 1) {
          // 固定尺寸
          // 过滤没有填的数据
          this.fenceNum1.forEach((item) => {
            if (item) {
              data.push(item);
            }
          });
        } else if (this.chooseSize == 2) {
          // 自由尺寸
          this.fenceNum2.forEach((item) => {
            if (item) {
              data.push(item);
            }
          });
        }
        this.temporarilyfenceNum = data;

        // 构造数据
        let canvasID = 1;
        const fencedata = [];
        for (let i = 0; i < this.temporarilyfenceNum.length; i++) {
          fencedata.push({
            alllength: this.temporarilyfenceNum[i], // 每一面围栏的总长
            canvasID: `canvasId${canvasID++}` // 每一个canvasid
          });
        }
        this.fenceDate.fenceData = fencedata; // 保存数据
        if (this.fenceDate.fenceSize) {
          // 构造围栏颜色数据
          this.getFenceColorData(this.fenceDate.fenceSize.boardNum);
        }

        // 根据围栏的面数构造数据板子柱子等传给后台的数据 并且默认展示第一面数据
        this.getFenceDataArr(this.temporarilyfenceNum);

        // 默认基础颜色数据
        this.baseColor = '#8E6032'; // 默认基础颜色
        this.middleColColor = '#394044'; // 默认柱子颜色
      }

      // 选择基础颜色的下一步
      if (this.current == 3) {
        // 改变 围栏数据中所有颜色
        this.fenceAllData.forEach((item) => {
          item.columnColor = this.middleColColor; // 柱子颜色
          item.boards.forEach((board) => {
            board.color = this.baseColor; // 遍历板子数组，都改为基础颜色
          });
        });

        this.fencecolor = this.baseColor.slice(-6);
      }

      // 选择颜色的下一步
      if (this.current == 4) {
        // 保存数据
        this.fenceAllData.forEach((oneFence) => {
          oneFence.boards = JSON.parse(JSON.stringify(this.fenceColorData));
          oneFence.columnColor = this.middleColColor;
        });
        // this.getDrawFenceData();
        // 构造画围栏颜色等数据
        this.getDrawFenceData();

        // 获取报价单数据
        this.getquotationFn();
      }

      // 选择防开框的下一步
      // if (this.current == 5) {
      //   this.fenceAllData.forEach((oneFence) => {
      //     oneFence.isFrame = this.isHaveFixed;
      //   });
      //   // 构造画围栏颜色等数据
      //   this.getDrawFenceData();

      //   // 获取报价单数据
      //   this.getquotationFn();
      // }

      this.current++;
    },

    // 最新公式计算
    newformula(reallength) {
      const colNum = Math.floor(reallength / 2000); // 列数向下取整
      const lastNum = reallength % 2000; // 余数
      let allColNum = null;
      let lastBoardLength = null;

      if (colNum === 0) {
        // 只有一列 为两端立柱
        this.fixColNum = 0;
        this.lastStructure = `100 | ${reallength - 200} | 100`;
        this.lastStructureType = 10;
        lastBoardLength = reallength;
        allColNum = 2;
      } else if (colNum === 1) {
        // 有两列 检查余数
        this.fixColNum = 0;
        if (lastNum >= 500) {
          // 大于等于500 按lastNum一板
          this.lastStructure = `100 | 1800 | 100 || ${reallength - 2000 - 100} | 100`;
          this.lastStructureType = 9;
          lastBoardLength = lastNum;
          allColNum = 3;
        } else if (lastNum > 0 && lastNum < 500) {
          // 大于0 小于500 和前一列平分两板
          this.lastStructure = `100 || ${(reallength - 200) / 2 - 100} | 100 | ${(reallength - 200) / 2} || 100`;
          this.lastStructureType = 8;
          lastBoardLength = reallength / 2;
          allColNum = 3;
        } else {
          // 刚好为0 结尾不用处理了
          this.lastStructure = ``;
          this.lastStructureType = 7;
          lastBoardLength = reallength;
          allColNum = 2;
        }
      } else {
        // 三列以上
        // 判断余数
        if (lastNum === 0) {
          // 刚好为0 结尾不用处理了
          this.fixColNum = colNum;
          this.lastStructure = ``;
          this.lastStructureType = 7;
          lastBoardLength = 2000;
          allColNum = this.fixColNum + 1; // 一列一个柱子 第一列多按一个柱
        } else if (lastNum >= 500) {
          // 大于等于500 按lastNum一板
          this.fixColNum = colNum;
          this.lastStructure = `${lastNum - 100} | 100`;
          this.lastStructureType = 6;
          lastBoardLength = lastNum;
          allColNum = this.fixColNum + 1 + 1; // 一列一个柱子 第一列多按一个柱 后边有余数 多一个柱
        } else {
          // 小于500 和前一列平分两板
          this.fixColNum = colNum - 1;
          this.lastStructure = `${(2000 + lastNum - 200) / 2} | 100 || ${(2000 + lastNum - 200) / 2} | 100`;
          this.lastStructureType = 5;
          lastBoardLength = (2000 + lastNum) / 2;
          allColNum = this.fixColNum + 1 + 2; // 一列一个柱子 第一列多按一个柱 后边有余数平分2列 多两个柱
        }
      }
      return {
        lastBoardLength,
        allColNum
      };
    },
    // 动态设置围栏尺寸示意
    setSelectionHeight(height) {
      const size = height.colHeight / 20;

      if (size == 8) {
        this.fenceregionHeight = '45%';
        this.fenceitemHeight = '10%';
        this.jointitemstyleSize = '120%';
        this.jointitemstyleSize1 = '160%';
      } else if (size == 10) {
        this.fenceregionHeight = '58%';
        this.fenceitemHeight = '9%';
        this.jointitemstyleSize = '120%';
        this.jointitemstyleSize1 = '150%';
      } else if (size == 12) {
        this.fenceregionHeight = '45%';
        this.fenceitemHeight = '7%';
        this.jointitemstyleSize = '70%';
        this.jointitemstyleSize1 = '100%';
      } else if (size == 15) {
        this.fenceregionHeight = '60%';
        this.fenceitemHeight = '7%';
        this.jointitemstyleSize = '80%';
        this.jointitemstyleSize1 = '100%';
      } else if (size == 18) {
        this.fenceregionHeight = '70%';
        this.fenceitemHeight = '5.5%';
        this.jointitemstyleSize = '50%';
        this.jointitemstyleSize1 = '60%';
      } else if (size == 20) {
        this.fenceregionHeight = '78%';
        this.fenceitemHeight = '5%';
        this.jointitemstyleSize = '36%';
        this.jointitemstyleSize1 = '34%';
      } else if (size == 24) {
        this.fenceregionHeight = '80%';
        this.fenceitemHeight = '4.5%';
        this.jointitemstyleSize = '36%';
        this.jointitemstyleSize1 = '34%';
      }
    },

    // 后台获取报价单
    async getquotationFn() {
      // 构造数据传给后台
      const platTypeSize = this.fenceAllData[0].platType.split('-');
      const fenceHttpData = JSON.parse(JSON.stringify(this.fenceAllData));
      console.log('报价单');
      console.log(platTypeSize);
      fenceHttpData.forEach((item) => {
        item.boardRowCount = Number(platTypeSize[1]); // 每列板数
        item.platType = `T-${platTypeSize[0]}`; // 围栏类型
        item.columnCount = this.newformula(item.allLength).allColNum; // 所有柱子数量
        item.lastBoardLength = this.newformula(item.allLength).lastBoardLength; // 最后一块板子长度
      });

      console.log('🚀 ~ file: HomeView.vue:892 ~ fenceHttpData.forEach ~ fenceHttpData:', fenceHttpData);
      // 获取后台报价单数据
      const { data } = await getquotationHttp(fenceHttpData);
      if (data.code == 0) {
        const res = data.result;
        this.quotationList = JSON.parse(JSON.stringify(res)); // 拷贝报价单数据
      } else {
        Message({
          message: '生成报价单失败',
          type: 'error'
        });
        return;
      }
    },
    // 单选框AC切换
    chooseDrawACFn(value) {
      const arr = value.split('-');
      const label = parseInt(arr[0]);
      const board = parseInt(arr[1]);
      this.fenceRange = label + '-' + board;
      this.fenceSize = [];
      for (let i = 1; i <= board; i++) {
        this.fenceSize.push({
          label: `ボード${i}段貼に変更`,
          value: `${label}-${i}`
        });
      }
    },

    // 型号过滤
    sizeFilter(size) {
      // 构造对象
      const sizeData = {
        boardNum: null, // 每列板子数量
        colHeight: null // 柱子高度
      };
      const sizeArr = size.split('-');
      // 例如"15-6" 高度是 15*20 板数是6
      if (sizeArr.length > 0) {
        sizeData.boardNum = Number(sizeArr[1]);
        sizeData.colHeight = sizeArr[0] * 20;
        sizeData.fenceType = size;
      }
      return sizeData;
    },

    // 更改基础颜色
    changeBaseColor(e) {
      // 将所有数据的颜色改为基础颜色
      this.baseColor = e;
      this.fenceColorData.forEach((item) => {
        item.color = e;
      });
      if (e == '#E0E0E0') {
        this.middleColColor = e;
      } else if (e == '#fad390') {
        this.middleColColor = '#e0d1aa'; // 柱子颜色
      } else {
        this.middleColColor = '#394044';
      }
    },

    // 重置基础色
    resetColorFn() {
      // 将所有数据的颜色改为基础颜色
      this.fenceColorData.forEach((item) => {
        item.color = this.baseColor;
      });
      if (this.baseColor == '#E0E0E0') {
        this.middleColColor = this.baseColor;
      } else if (this.baseColor == '#fad390') {
        this.middleColColor = '#e0d1aa'; // 柱子颜色
      } else {
        this.middleColColor = '#394044';
      }

      this.fencecolor = this.baseColor.slice(-6);
    },

    // 改变板子颜色点击事件
    changeColorFn(index) {
      // 记录index值
      this.colorIndex = index;
      this.fencecolor = this.fenceColorData[index].color.slice(-6); // 截取除'#'后六位 改变颜色单选的值
    },

    // 改变板子颜色
    changeColor(e) {
      this.fenceColorData[this.colorIndex].color = '#' + e;

      // 判断是否全部改变时
      // let isSame = true;
      // for (let i = 0; i < this.fenceColorData.length; i++) {
      //   if (this.fenceColorData[i].color !== this.fenceColorData[0].color) {
      //     isSame = false;
      //   }
      // }
      // if (isSame) {
      //   if (this.fenceColorData[0].color == '#fad390') {
      //     // 如果板子颜色全部为橡木色时，柱子的颜色变为暖灰色
      //     this.middleColColor = '#e0d1aa';
      //   }
      // }

      // 为了点击颜色切换单选框
      this.fencecolor = e;
    },

    // 改变放开框
    changeFixedFn(e) {
      this.fenceAllData[this.pageNum - 1].isFrame = e;
    },

    // 构造围栏颜色数据
    getFenceColorData(num) {
      if (num) {
        let fenceId = 1;
        const data = [];
        for (let i = 0; i < num; i++) {
          const colordata = {
            color: '#8E6032',
            fenceId: fenceId++
          };
          data.push(colordata);
        }

        this.fenceColorData = data;
      }
    },

    // 根据围栏的面数构造数据板子柱子等传给后台的数据
    getFenceDataArr(num) {
      const data = [];
      const res = JSON.parse(JSON.stringify(this.fenceColorData));

      for (let i = 0; i < num.length; i++) {
        const obj = {
          allLength: num[i], // 每一面的长度
          isFrame: 1, // 是否安装放开框
          platType: this.fenceDate.fenceSize.fenceType, // 围栏类型
          boards: res, // 板子颜色数组
          columnColor: '#394044', // 柱子颜色 this.middleColColor
          mode: parseInt(this.step1Radio) // 施工方式选择 1独立施工 2混泥土施工
        };
        data.push(obj);
      }
      this.fenceAllData = data;
    },

    // 报价单表格合计
    getSummaries(param, number) {
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = `第${number + 1}ライン計`;
          return;
        }

        if (index === columns.length - 1) {
          const total = data.map((row) => row.count * row.unitPrice).reduce((total, num) => total + num);
          sums[index] = '¥' + numberToCurrencyNo(total);
        }
      });
      return sums;
    },

    // 生成报价单
    async generatequotationFn() {
      const platTypeSize = this.fenceAllData[0].platType.split('-');
      let allimage = new FormData();

      // 构造后台数据
      const quotationListHttpData = JSON.parse(JSON.stringify(this.quotationList));

      quotationListHttpData.forEach((item) => {
        item.quotationDataList.forEach((col) => {
          col.totalPrice = col.count * col.unitPrice;
        });
        item.allQuotataionPrice = this.alltotalPrice;
        item.boardRowCount = Number(platTypeSize[1]);
        item.platType = `T-${platTypeSize[0]}`;
      });

      // 放入截图
      for (let i = 0; i < this.fenceDate.fenceData.length; i++) {
        // 遍历组件ref获取每面的截图form数据
        const FormData = await this.$refs[i][0].getCanvas(); // 接受返回的promise
        const res = FormData.getAll('image'); // 获取表单数据

        for (let j = 0; j < res.length; j++) {
          // 遍历file数据添加到构造表单
          if (res.length === 0 || (res.length === 1 && res[0].name.indexOf('right_') > -1)) {
            // 没有file 或者 只有一个file且是右边图 为生成异常 重新生成
            this.generatequotationFn();
            return false;
          }
          allimage.append('file', res[j]);
          if (res.length == 1) {
            // 如果只有左边 给数据赋值用作标记
            quotationListHttpData[i].leftExampleImage = res[0].name;
          } else {
            quotationListHttpData[i].leftExampleImage = res[0].name; // 左图片
            quotationListHttpData[i].rightExampleImage = res[1].name; // 右图片
          }
        }
      }

      // 将数据写入表单一起传入后台
      allimage.append('dataListString', JSON.stringify(quotationListHttpData));

      // 调接口获取文件流
      const { data } = await getquotationPDFHttp(allimage);

      // 根据流文件下载pdf
      download(new Blob([data]), '見積書.pdf', 'application/pdf');
    },

    // 生成CSV
    async getCsvFn() {
      const platTypeSize = this.fenceAllData[0].platType.split('-');
      let csvData = new FormData();

      // 构造后台数据
      const quotationListHttpData = JSON.parse(JSON.stringify(this.quotationList));

      quotationListHttpData.forEach((item) => {
        item.quotationDataList.forEach((col) => {
          col.totalPrice = col.count * col.unitPrice;
        });
        item.allQuotataionPrice = this.alltotalPrice;
        item.boardRowCount = Number(platTypeSize[1]);
        item.platType = `T-${platTypeSize[0]}`;
      });

      // 将数据写入表单一起传入后台
      csvData.append('dataListString', JSON.stringify(quotationListHttpData));

      // 调后台接口
      const { data } = await getquotationCSVHttp(csvData);

      // 根据流文件下载csv
      download(new Blob([data]), '見積書.csv', 'application/csv');
    },

    // 构造画围栏的数据
    getDrawFenceData() {
      this.fenceDate.fenceData.forEach((item, index) => {
        item.colorData = this.fenceAllData[index].boards;
        item.columnColor = this.fenceAllData[index].columnColor;
      });
    },

    // 完成刷新页面
    finishFn() {
      // 强制刷新页面
      window.location.reload();
    }
  }
};
</script>

<style scoped>
/* v-if动画 */
.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

.fade1-enter {
  opacity: 0;
}

.fade1-enter-active {
  animation: fade-in 0.5s;
  animation-fill-mode: backwards;
  animation-delay: 0.5s;
}

@keyframes fade-in {
  0% {
    opacity: 0;
    display: none;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* v-if动画 */
.step2 {
  margin: 5% auto 0 auto;
  padding: 3%;
  width: 76%;
  height: 700px;
  display: flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 15px rgb(214, 214, 214);
}

.step3 {
  margin: 5% auto 0 auto;
  padding: 3%;
  width: 60%;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 15px rgb(214, 214, 214);
}

.chooseSizeStyle {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 30px;
}

.lengthInputStyle {
  flex: 20%;
  margin-bottom: 20px;
}

.step4 {
  position: relative;
  margin: 5% auto 0 auto;
  padding: 3%;
  width: 80%;
  height: 730px;
  display: flex;
  justify-content: space-between;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 15px rgb(214, 214, 214);
}

.step4-1 {
  width: 80%;
  padding: 3%;
  margin: 5% auto 0 auto;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 15px rgb(214, 214, 214);
}

.step4Style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 900px;
}

.step4-1-title {
  position: absolute;
  top: 0;
  left: 0;
}

.step5bottomstyle {
  padding-bottom: 10%;
}

.paginationStyle {
  position: absolute;
  right: 2%;
  bottom: 2%;
}

.step5 {
  margin: 5% auto 0 auto;
  padding: 3%;
  width: 80%;
  /* height: 700px;
  display: flex; */
  /* flex-direction: column;
  justify-content: center; */
  /* justify-content: space-between; */
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 15px rgb(214, 214, 214);
  /* margin-top: 60px;
  margin: 80px; */
}

.total {
  padding: 2% 3%;
  display: flex;
  justify-content: right;
}

.tableStyle {
  margin-top: 10px;
}

.chooseColorStyle {
  display: flex;
  flex-direction: column;
  width: 46%;
  height: 100%;
  margin-top: 30px;
  /* background-color: aquamarine; */
}

.chooseFixedStyle {
  margin: 20px 0;
  height: 280px;
  width: 90%;
  background-image: url('../assets/fixed.jpg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.resetBtn {
  float: right;
  margin-bottom: 20px;
}

.topItemStyle {
  width: 100%;
  flex: 1.2;
  /* background-color: rgb(185, 255, 127); */
}

/* 选择颜色区域样式 */
.middleItemStyle {
  /* display: flex; */
  /* justify-content: center; */
  width: 100%;
  /* flex: 1.5; */
  /* background-color: brown; */
}

.middleTitleStyle {
  position: relative;
  padding: 3px 0;
  text-align: center;
  background-color: #f2f6fc;
  border-radius: 30px;
}

.changeStyle {
  position: absolute;
  right: 3%;
}

.fencecolorStyle {
  margin-top: 10px;
  display: flex;
  /* padding: 0 26px; */
  justify-content: space-between;
}

.colorRegion {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.colColorStyle {
  display: flex;
  justify-content: center;
}

.colorItemStyle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 10px;
  cursor: pointer;
}

.bottomItemStyle {
  width: 100%;
  flex: 1;
  /* background-color: blue; */
}

.fixStyle {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.fenceregion {
  position: relative;
  /* background-color: aqua; */
  width: 44%;
}

.fenceregion4-1 {
  height: 70%;
}

.fencestyle {
  position: absolute;
  top: 0;
  left: 3%;
  width: 94%;
  height: 100%;
}

/* 固定插冒 */

/* 板子样式 */
.fenceitem {
  width: 100%;
  height: 5%;
  margin-top: 1%;
  cursor: pointer;
}

/* 柱子区域样式 */
.colstyle {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  /* background-color: bisque; */
}

.colstyleitem {
  width: 3%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  margin: 0 20px;
}

.jointitemstyle {
  box-sizing: content-box;
  width: 100%;
  height: 5%;
  padding-top: 40%;
  /* background-color: aqua; */
}

.step4fence {
  overflow-x: auto;
  margin-bottom: 10px;
  text-align: center;
}

.step2RadioStyle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40%;
  height: 100%;
}

.chooseItemStyle {
  margin-bottom: 20px;
  font-size: 20px;
}

.imgBoxStyle {
  display: flex;
  text-align: center;
  justify-content: center;
  width: 80%;
  height: 400px;
  margin: 5% auto 0 auto;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 15px rgb(214, 214, 214);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  display: -webkit-box;
}

.constructionImg1 {
  margin: 20px auto;
  width: 1100px;
  background-image: url('../assets/dulishigong.jpg');
  background-size: 1100px;
  background-repeat: no-repeat;
  background-position: center;
}

.constructionImg2 {
  margin: 20px auto;
  width: 1000px;
  background-image: url('../assets/hunheshigong.jpg');
  background-size: 1000px;
  background-repeat: no-repeat;
  background-position: center;
}

.choseBox {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: 60px;
  margin: 3% auto 0 auto;
}

.stepsbtn {
  position: fixed;
  z-index: 999;
  bottom: 5%;
  right: 5%;
  height: 60px;
  margin: 3% auto 0 auto;
}

.step2Drawing img {
  width: 100%;
}

.inputNumStyle {
  margin-right: 20px;
  margin-top: 10px;
}

.el-avatar,
.el-cascader-panel,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label {
  font-size: 16px;
}

/* 下拉选样式 */
.selectStyle {
  width: 60%;
}

.colorColStyle {
  display: flex;
}

.colorColStyle > .colorRegion {
  width: 20%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.fencecolorStyle1 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.el-radio.is-bordered + .el-radio.is-bordered {
  margin-right: 10px !important;
  margin-left: 0 !important;
}

@media only screen and (max-width: 912px) {
  .stepsbtn {
    bottom: 2%;
    right: 0;
    display: flex;
    height: 40px;
  }

  .imgBoxStyle {
    width: 80%;
    height: 460px;
  }

  .choseBox {
    width: 80%;
  }

  .step2 {
    width: 83%;
    height: 80%;
    flex-direction: column;
    align-items: center;
  }

  .step3 {
    width: 80%;
    height: 950px;
  }

  .step4 {
    width: 90%;
    flex-direction: column;
    padding-bottom: 70px;
  }

  .step4-1 {
    width: 90%;

    height: 1200px;
    padding-bottom: 76px;
  }

  .step4Style {
    flex-direction: column;
    height: 1040px;
  }

  .fenceregion {
    width: 100%;
    height: 60%;
  }

  .chooseColorStyle {
    width: 100%;
  }

  .fencecolorStyle1 {
    flex-direction: column;
    justify-content: space-around;
  }

  .colorColStyle {
    display: flex;
  }

  .colorRegion {
    width: 30%;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .middleTitleStyle {
    margin-top: 20px;
  }

  .step2RadioStyle {
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    margin-bottom: 50px;
  }

  .selectStyle {
    margin-left: 0;
  }

  .chooseItemStyle {
    margin-left: 0;
  }

  .chooseSizeStyle {
    text-align: center;
  }

  .resetBtn {
    margin: 0;
    margin-top: 20px;
  }

  .chooseFixedStyle {
    height: 170px;
  }

  .step5 {
    width: 90%;
  }

  .total {
    margin-bottom: 40px;
  }

  .el-button.is-round {
    padding: 12px 16px !important;
  }
}

@media only screen and (max-width: 400px) {
  .imgBoxStyle {
    width: 80%;
    height: 400px;
  }

  .choseBox {
    width: 80%;
  }
}
</style>
